import React from 'react';
import { Card, CardBody, Button, Badge } from 'reactstrap';
import { H5, P } from '../../../../AbstractElements';

const QuizCard = ({ quiz, onEdit, onDelete, onToggleStatus, onViewQuestions }) => {
  return (
    <Card className="shadow-sm border-0 mb-4">
      <CardBody className="p-3">
        {/* Thumbnail Preview */}
        {(quiz.url || quiz.thumbnailUrl) && (
          <div className="mb-3">
            <img 
              src={quiz.url || quiz.thumbnailUrl} 
              alt={quiz.name}
              className="img-fluid rounded"
              style={{width: '100%', height: '180px', objectFit: 'cover'}}
            />
          </div>
        )}

        <div className="d-flex justify-content-between align-items-start mb-3">
          <div className="flex-grow-1">
            <div className="d-flex align-items-center gap-2 mb-2">
              <Badge color={quiz.isActive ? 'success' : 'secondary'}>
                {quiz.isActive ? 'Active' : 'Inactive'}
              </Badge>
              <Badge color="primary">
                <i className="fa fa-question-circle me-1"></i>
                {quiz.totalQuestions || (quiz.questions?.length || 0)} câu hỏi
              </Badge>
              {quiz.displayQuestions && (
                <Badge color="info">
                  <i className="fa fa-eye me-1"></i>
                  Hiển thị: {quiz.displayQuestions}
                </Badge>
              )}
            </div>
            <H5 className="text-dark mb-1">{quiz.name}</H5>
          </div>
          <div className="d-flex gap-1 align-items-center">
            <Button 
              color="outline-info" 
              size="sm"
              className="p-2"
              onClick={() => onViewQuestions(quiz)}
              title="Xem câu hỏi"
            >
              <i className="fa fa-list"></i>
            </Button>
            <Button 
              color="outline-primary" 
              size="sm"
              className="p-2"
              onClick={() => onEdit(quiz)}
              title="Chỉnh sửa"
            >
              <i className="fa fa-edit"></i>
            </Button>
            <Button 
              color="outline-danger" 
              size="sm"
              className="p-2"
              onClick={() => onDelete(quiz.id)}
              title="Xóa"
            >
              <i className="fa fa-trash"></i>
            </Button>
          </div>
        </div>

        {/* Quiz Stats */}
        <div className="mb-3 p-3 bg-light rounded">
          <div className="row g-2 text-center">
            <div className="col-4">
              <small className="text-muted d-block">Tổng câu hỏi</small>
              <strong className="text-primary">{quiz.totalQuestions || (quiz.questions?.length || 0)}</strong>
            </div>
            <div className="col-4">
              <small className="text-muted d-block">Hiển thị</small>
              <strong className="text-info">{quiz.displayQuestions || 0}</strong>
            </div>
            <div className="col-4">
              <small className="text-muted d-block">Question Types</small>
              <div className="d-flex gap-1 justify-content-center">
                {quiz.questions && (
                  <>
                    <small className="text-primary">
                      {quiz.questions.filter(q => q.type === 'single').length} Single
                    </small>
                    <small className="text-muted">|</small>
                    <small className="text-warning">
                      {quiz.questions.filter(q => q.type === 'multi').length} Multi
                    </small>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
          <small className="text-muted mb-0">
            {quiz.createdAt && `Created: ${new Date(quiz.createdAt).toLocaleDateString('vi-VN')}`}
          </small>
          <Button
            color={quiz.isActive ? 'warning' : 'success'}
            size="sm"
            className="ms-3"
            onClick={() => onToggleStatus(quiz.id)}
          >
            <i className={`fa fa-${quiz.isActive ? 'eye-slash' : 'eye'} me-1`}></i>
            {quiz.isActive ? 'Tắt' : 'Bật'}
          </Button>
        </div>
      </CardBody>
    </Card>
  );
};

export default QuizCard;

